import { Injectable } from '@angular/core';
import { LoginUserPayload, readStoredLoginUser } from '../layouts/full/vertical/sidebar/sidebar-role.util';
import { PermissionFlags, UserPermissionsMap } from './api-interface.service';

export type PermissionAction = 'view' | 'create' | 'edit' | 'delete';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private admin = false;
  private legacy = false;
  private permissions: UserPermissionsMap = {};

  constructor() {
    this.hydrateFromStoredUser();
  }

  hydrateFromStoredUser(): void {
    this.setFromUser(readStoredLoginUser());
  }

  setFromUser(user: LoginUserPayload | null | undefined): void {
    this.admin = !!user && (
      user.is_superuser === true
      || ['admin', 'administrator', 'super admin', 'superadmin', 'system administrator']
        .includes(String(user.role ?? '').trim().toLowerCase())
    );
    this.legacy = !!user && user.permissions == null;
    this.permissions = (user?.permissions || {}) as UserPermissionsMap;
  }

  setPermissions(permissions: UserPermissionsMap, isAdmin = false): void {
    this.admin = isAdmin || this.admin;
    this.legacy = false;
    this.permissions = permissions || {};
    const stored = readStoredLoginUser();
    if (stored) {
      stored.permissions = this.permissions;
      stored.is_superuser = stored.is_superuser || isAdmin;
      try {
        localStorage.setItem('user', JSON.stringify(stored));
      } catch {
        /* ignore quota / private mode */
      }
    }
  }

  isAdmin(): boolean {
    return this.admin;
  }

  can(module: string, action: PermissionAction = 'view'): boolean {
    if (!module) return true;
    if (this.legacy) {
      if (this.admin) return true;
      if (module === 'users' || module === 'roles') return false;
      return action === 'view';
    }
    const flags = this.permissions?.[module] as PermissionFlags | undefined;
    if (this.admin && !flags) return true;
    if (!flags) return false;
    return !!flags[`can_${action}`];
  }

  canKey(key: string): boolean {
    const [module, action] = (key || '').split('.');
    return this.can(module, (action as PermissionAction) || 'view');
  }
}
